import { useState } from 'react';
import InitFilters from './ListServiceSets/constants/InitFiltering';

const useCustomHook = () => {
  const [loadingPage, setLoadingPage] = useState(false);
  const [loadingBtn, setLoadingBtn] = useState(false);
  const [loadingBtnDialog, setLoadingBtnDialog] = useState(false);

  const [openSnack, setOpenSnack] = useState(false);
  const [webServicesSearch, setWebServicesSearch] = useState([]);
  const [webServicesList, setWebServicesList] = useState([]);
  const [images, setImages] = useState({ logo: null });
  const [imageData, setImageData] = useState({
    src: '',
    uploadDetails: {},
    uploaded: false,
    removed: false,
  });
  const [editPage, setEditPage] = useState(false);
  const [selectedForRemove, setSelectedForRemove] = useState({});
  const [page, setPage] = useState(0);

  const [loading, setLoading] = useState(false);
  const [, setFilterParams] = useState(null);
  const [size, setSize] = useState(10);
  const [filters, setFilters] = useState(InitFilters());
  const [dialogContent, setDialogContent] = useState({
    title: '',
    content: '',
  });
  const [selectedRow, setSelectedRow] = useState({});
  const [requestAction, setRequestAction] = useState('');
  const [openDialog, setOpenDialog] = useState(false);
  

  return {
    loading, setLoading,
    setFilterParams,
    size, setSize,
    filters, setFilters,
    dialogContent, setDialogContent,
    selectedRow, setSelectedRow,
    requestAction, setRequestAction,
    loadingPage,
    setLoadingPage,
    page, setPage,
    loadingBtnDialog, setLoadingBtnDialog,
    loadingBtn,
    setLoadingBtn,
    openSnack,
    setOpenSnack,
    webServicesSearch,
    setWebServicesSearch,
    webServicesList,
    setWebServicesList,
    images,
    setImages,
    imageData,
    setImageData,
    openDialog,
    setOpenDialog,
    editPage,
    setEditPage,
    selectedForRemove,
    setSelectedForRemove,
  };
};

export default useCustomHook;
